/* eslint-disable react/jsx-one-expression-per-line */
/* eslint-disable react/jsx-curly-newline */
/* eslint-disable implicit-arrow-linebreak */
import PropTypes from 'prop-types';
import React, {Component} from 'react';
import {Button, Col} from 'react-bootstrap';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as AppStateAction from '../../../stores/actions/appStateAction';
import * as ModalStateAction from '../../../stores/actions/modalStateAction';
import * as NormalizationStateAction from '../../../stores/actions/normalizationStateAction';
import {removeTemporaryState} from '../../../stores/actions/temporaryStateAction';
import {restoreCardState, restoreCardTaskState} from '../../../stores/actions/cardStateAction';
import {setSelectedLabwareID} from '../../../stores/actions/protocolEditorAction';
import {finishNormalization} from '../../../stores/business/taskListBusinessAction';
import NormalizationViewCsvUpload from './NormalizationViewCsvUpload';
import NormalizationViewFileSetting from './NormalizationViewFileSetting';
import NormalizationViewDataPreview from './NormalizationViewDataPreview';
import NormalizationViewTargetSetting from './NormalizationViewTargetSetting';
import NormalizationViewVolumeList from './NormalizationViewVolumeList';
import {ViewMode, WellIncrementPattern, NormalizationPreviewWellStatus, Feedback} from '../../../constants/dataEnum';
import * as TemporaryStateType from '../../../constants/temporaryStateType';
import NormalizationViewDiluentVolumeList from './NormalizationViewDiluentVolumeList';
import NormalizationViewDataResume from './NormalizationViewDataResume';
// import { temporaryState, setTemporaryState } from '../../labwareHelper';
import './NormalizationContainer.scss';

const cancelNormalizationTaskMessage = {
  TITLE: 'Cancel Normalization Task',
  MESSAGE_FIRST_LINE:
    'Cancelling the concentration normalization task will remove all of the changes that you have made. This action cannot be undone.',
  MESSAGE_SECOND_LINE: 'Do you want to continue?',
  BUTTON_YES: 'YES',
  BUTTON_NO: 'NO',
};

const sideMenuSelectNormalizationModeMessage = {
  RED_TEXT: 'Select the diluent labware on the middle panel, then specify the diluent name.',
  BLUE_TEXT: 'Tap NEXT to proceed to the next step.',
};

const fileIsNotSupportedMessage = 'File is not supported';

class NormalizationContainer extends Component {
  constructor(props) {
    super(props);
    const {normalizationState} = this.props;
    this.state = {
      initial: {
        initialDelimiter: normalizationState.delimiter,
        initialStartRow: normalizationState.startRow,
        initialColumnInFirstRow: normalizationState.isColumnInFirstRow,
        initialWellIncrementPattern: normalizationState.wellIncrementPattern,
        initialSelectedColumnIndex: normalizationState.selectedColumnIndex,
      },
      isCsvChanged: false,
    };
  }

  handleDiluentLabwareClick(selectedDiluentLabwareID) {
    const {setDiluentLabwareID, normalizationState} = this.props;
    if (selectedDiluentLabwareID === normalizationState.selectedDiluentLabwareID) {
      setDiluentLabwareID(0);
    } else setDiluentLabwareID(selectedDiluentLabwareID);
  }

  handleNext(currentWizardView) {
    const {
      incrementCurrentWizardView,
      resetNormalizationCurrentVolume,
      setDefaultTargetConcentration,
      normalizationState,
      resetDefaultCurrentVolume,
    } = this.props;
    const currentState = {
      initialDelimiter: normalizationState.delimiter,
      initialStartRow: normalizationState.startRow,
      initialColumnInFirstRow: normalizationState.isColumnInFirstRow,
      initialWellIncrementPattern: normalizationState.wellIncrementPattern,
      initialSelectedColumnIndex: normalizationState.selectedColumnIndex,
    };
    const {initial} = this.state;
    const equalState = Object.keys(currentState).every((k) => initial[k] === currentState[k]);
    this.setState({initial: currentState});
    if (currentWizardView === 1) {
      const {isCsvChanged} = this.state;
      if (!equalState || isCsvChanged) {
        const {targetConcentration} = this.generatePreviewData();
        resetNormalizationCurrentVolume();
        setDefaultTargetConcentration(targetConcentration);
        resetDefaultCurrentVolume();
      }
      incrementCurrentWizardView();
      // appStateAction.saveProtocol();
    } else {
      incrementCurrentWizardView();
      // appStateAction.saveProtocol();
    }
  }

  handleCancel() {
    // show warning
    // const { modalStateAction, appStateAction } = this.props;
    const {modalStateAction} = this.props;
    const discardProtocolText = (
      <div id="discard-protocol-text">
        {cancelNormalizationTaskMessage.MESSAGE_FIRST_LINE}
        <br />
        {cancelNormalizationTaskMessage.MESSAGE_SECOND_LINE}
      </div>
    );
    modalStateAction.showModal(
      cancelNormalizationTaskMessage.TITLE,
      discardProtocolText,
      [
        {
          className: 'btn-lg',
          style: 'primary',
          handlerClick: () => {
            this.onCancel();
            this.onBackToNormalView();
            modalStateAction.hideModal();
            // appStateAction.saveProtocol();
          },
          text: cancelNormalizationTaskMessage.BUTTON_YES,
        },
        {
          className: 'btn-lg',
          style: 'secondary',
          handlerClick: () => {
            modalStateAction.hideModal();
          },
          text: cancelNormalizationTaskMessage.BUTTON_NO,
        },
      ],
      () => modalStateAction.hideModal(),
    );
  }

  handleFinish() {
    // const { convertNormalizationStateToCardDetail, addCard, setUngroupedCardDetail } = this.props;
    // convertNormalizationStateToCardDetail();

    // if (!temporaryState) {
    //   addCard('Normalization Task', CardType.NORMALIZATION);
    // } else {
    //   const { card } = temporaryState;
    //   editCardTasks(card.ID);
    //   setTemporaryState(null);
    // }
    // setUngroupedCardDetail();
    const {taskListBusinessFinishNormalization} = this.props;
    taskListBusinessFinishNormalization();
    this.onBackToNormalView();
  }

  handleChangeStartRow(startRow) {
    const {setCsvStartRow, normalizationState} = this.props;
    console.log('>>> startRow:', startRow);
    setCsvStartRow(startRow);
    this.handleChangeAllowedToNext(true, startRow, normalizationState.selectedColumnIndex);
  }

  handleChangeAllowedToNext(isAllowedToNext, startRow, selectedColumnIndex) {
    const {normalizationState, setAllowedToNext} = this.props;
    const {totalRow, selectedLabware, allowedToNext} = normalizationState;
    const {colCount, rowCount} = selectedLabware;

    if (isAllowedToNext) {
      console.log('>>> totalRow:', totalRow);
      console.log('>>> totalRow - (startRow - 1):', totalRow - (startRow - 1));
      console.log('>>> colCount * rowCount:', colCount * rowCount);
      console.log('>>> selectedColumnIndex:', selectedColumnIndex);
      if (
        totalRow > 0 &&
        totalRow - (startRow - 1) <= colCount * rowCount &&
        selectedColumnIndex !== null &&
        selectedColumnIndex !== undefined
      ) {
        if (!allowedToNext) {
          setAllowedToNext(true);
        }
      } else if (allowedToNext) {
        setAllowedToNext(false);
      }
    } else if (allowedToNext) {
      setAllowedToNext(false);
    }
  }

  onBackToNormalView() {
    const {appStateAction, protocolEditorActionSetSelectedLabwareID} = this.props;
    appStateAction.changeView(ViewMode.PROTOCOL_EDITOR);
    protocolEditorActionSetSelectedLabwareID(0);
  }

  onCancel() {
    const {
      cardState,
      temporaryState,
      temporaryStateActionRemoveTemporaryState,
      cardStateActionRestoreCardState,
      cardStateActionRestoreCardTaskState,
      normalizationStateActionResetNormalizationState,
    } = this.props;
    if (temporaryState?.CARDS) {
      cardStateActionRestoreCardState({
        ...cardState.cards,
        [temporaryState[TemporaryStateType.CARDS].ID]: temporaryState[TemporaryStateType.CARDS],
      });
      cardStateActionRestoreCardTaskState(temporaryState[TemporaryStateType.TASKS]);
      temporaryStateActionRemoveTemporaryState(TemporaryStateType.CARDS);
      temporaryStateActionRemoveTemporaryState(TemporaryStateType.TASKS);
    }
    normalizationStateActionResetNormalizationState();
  }

  handleBack = () => {
    const {decrementCurrentWizardView, normalizationState} = this.props;
    const {startRow, selectedColumnIndex, currentWizardView} = normalizationState;

    if (currentWizardView === 2) {
      this.setState({isCsvChanged: false});
      this.handleChangeAllowedToNext(true, startRow, selectedColumnIndex);
    }

    decrementCurrentWizardView();
  };

  generatePreviewData() {
    const {normalizationState, setTargetConcentration, setLowestConcentration, setReagentName, setPreviewData} =
      this.props;
    const {
      csvData,
      startRow,
      selectedColumnIndex,
      isColumnInFirstRow,
      wellIncrementPattern,
      selectedLabware,
      currentVolume,
      lowestConcentration,
    } = normalizationState;
    let {targetConcentration} = normalizationState;

    // find lowest concentration on selected data
    let calcLowestConcentration = 10000.0;

    // get selected data
    const selectedData = [];
    for (let row = startRow - 1; row < csvData.length; row += 1) {
      selectedData.push(csvData[row][selectedColumnIndex]);
      if (calcLowestConcentration > csvData[row][selectedColumnIndex]) {
        calcLowestConcentration = csvData[row][selectedColumnIndex];
      }
    }
    if (targetConcentration !== calcLowestConcentration) {
      targetConcentration = calcLowestConcentration;
      setTargetConcentration(calcLowestConcentration);
    }
    if (calcLowestConcentration !== lowestConcentration) {
      setLowestConcentration(calcLowestConcentration);
    }
    console.table('selected data:', selectedData);
    console.log('lowest concentration:', calcLowestConcentration);

    // generate preview data
    const previewData = [];
    for (let idx = 0; idx < selectedData.length; idx += 1) {
      let diluentVolume = 0.0;
      if (calcLowestConcentration < selectedData[idx]) {
        diluentVolume = (currentVolume * selectedData[idx]) / calcLowestConcentration - currentVolume;
        diluentVolume = Math.round(diluentVolume * 10) / 10;
      }

      // calculate well status based on diluent volume and plate's working capacity
      let wellStatus = NormalizationPreviewWellStatus.NORMAL;
      if (
        diluentVolume + currentVolume > selectedLabware.workingCapacity ||
        calcLowestConcentration > selectedData[idx]
      ) {
        wellStatus = NormalizationPreviewWellStatus.INVALID;
      } else if (diluentVolume <= 0) {
        wellStatus = NormalizationPreviewWellStatus.SKIPPED;
      }

      let rowNumber = 0;
      let colNumber = 0;
      if (wellIncrementPattern === WellIncrementPattern.ORDER_BY_ROW) {
        rowNumber = Math.floor(idx / selectedLabware.colCount);
        colNumber = idx % selectedLabware.colCount;
      } else {
        colNumber = Math.floor(idx / selectedLabware.rowCount);
        rowNumber = idx % selectedLabware.rowCount;
      }

      // selectedLabware.colCount & selectedLabware.rowCount is misnamed (switched)
      previewData.push({
        row: rowNumber,
        col: colNumber,
        reagentCurrentConcentration: selectedData[idx],
        diluentVol: diluentVolume,
        status: wellStatus,
      });
    }

    // store the state
    if (isColumnInFirstRow) {
      setReagentName(csvData[0][selectedColumnIndex]);
    } else {
      setReagentName(`Reagent ${selectedColumnIndex + 1}`);
    }
    console.log('Normalization preview data:', previewData);
    setPreviewData(previewData);
    return {targetConcentration, currentVolume};
  }

  createFooterButtons(currentWizardView, allowedToNext) {
    if (currentWizardView === 1) {
      return (
        <>
          <Button className="primary" onClick={() => this.handleNext(currentWizardView)} disabled={!allowedToNext}>
            NEXT
          </Button>
          <Button className="secondary" onClick={() => this.handleCancel()}>
            CANCEL
          </Button>
        </>
      );
    }

    if (currentWizardView >= 2 && currentWizardView <= 3) {
      return (
        <>
          <Button className="primary" onClick={this.handleBack}>
            BACK
          </Button>
          <Button className="primary" onClick={() => this.handleNext(currentWizardView)} disabled={!allowedToNext}>
            NEXT
          </Button>
          <Button className="secondary" onClick={() => this.handleCancel()}>
            CANCEL
          </Button>
        </>
      );
    }
    if (currentWizardView === 4) {
      return (
        <>
          <Button className="primary" onClick={this.handleBack}>
            BACK
          </Button>
          <Button className="primary" onClick={() => this.handleFinish()} disabled={!allowedToNext}>
            FINISH
          </Button>
          <Button className="secondary" onClick={() => this.handleCancel()}>
            CANCEL
          </Button>
        </>
      );
    }
    return '';
  }

  createRightPanel(currentWizardView) {
    const {
      normalizationState,
      labwareState,
      setCsvDelimiter,
      setCsvColumnInFirstRow,
      setWellIncrementPattern,
      setCsvData,
      setCsvTotalRow,
      setSelectedColumnIndex,
      setAllowedToNext,
    } = this.props;
    let rightPanel = null;
    switch (currentWizardView) {
      case 1:
        rightPanel = (
          <div className="right-panel" style={{width: '30%'}}>
            <NormalizationViewFileSetting
              normalizationState={normalizationState}
              setCsvDelimiter={(delimiter) => setCsvDelimiter(delimiter)}
              setCsvStartRow={(startRow) => this.handleChangeStartRow(startRow)}
              setCsvColumnInFirstRow={(isColumnInFirstRow) => setCsvColumnInFirstRow(isColumnInFirstRow)}
              setWellIncrementPattern={(wellIncrementPattern) => setWellIncrementPattern(wellIncrementPattern)}
              setCsvData={(csvData) => setCsvData(csvData)}
              setCsvTotalRow={(totalRow) => setCsvTotalRow(totalRow)}
              setSelectedColumnIndex={(selectedColumnIndex) => setSelectedColumnIndex(selectedColumnIndex)}
              setAllowedToNext={(isAllowedToNext) =>
                this.handleChangeAllowedToNext(
                  isAllowedToNext,
                  normalizationState.startRow,
                  normalizationState.selectedColumnIndex,
                )
              }
            />
          </div>
        );
        break;
      case 2:
        rightPanel = (
          <div className="right-panel" style={{width: '40%'}}>
            <NormalizationViewVolumeList normalizationState={normalizationState} />
          </div>
        );
        break;
      case 3: {
        const diluentLabware = Object.values(labwareState).find(
          (lab) => lab.LabwareID === normalizationState.selectedDiluentLabwareID,
        );

        rightPanel = (
          <div className="right-panel" style={{width: '45%'}}>
            <NormalizationViewDataPreview
              normalizationState={normalizationState}
              diluentLabware={diluentLabware}
              setAllowedToNext={(isAllowedToNext) => setAllowedToNext(isAllowedToNext)}
              diluentSelectionView
            />
          </div>
        );
        break;
      }
      case 4:
        rightPanel = (
          <div className="right-panel" style={{width: '40%'}}>
            <NormalizationViewDiluentVolumeList normalizationState={normalizationState} />
          </div>
        );
        break;
      default:
        break;
    }
    return rightPanel;
  }

  createCenterPanel(currentWizardView) {
    const {labwareState, normalizationState, setAllowedToNext} = this.props;
    let centerPanel = null;
    switch (currentWizardView) {
      case 1:
        centerPanel = (
          <div className="center-panel" style={{width: '45%'}}>
            <NormalizationViewDataPreview normalizationState={normalizationState} patternView />
          </div>
        );
        break;
      case 2:
        centerPanel = (
          <div className="center-panel" style={{width: '45%'}}>
            <NormalizationViewDataPreview
              normalizationState={normalizationState}
              setAllowedToNext={(isAllowedToNext) => setAllowedToNext(isAllowedToNext)}
            />
          </div>
        );
        break;
      case 3: {
        const labwareTroughList = Object.values(labwareState).filter(
          (e) => e.isTrough && e.rowCount === 1 && e.colCount === 1,
        );

        const selectionLabwareComponent = [];
        for (let lIndx = 0; lIndx < labwareTroughList.length; lIndx += 1) {
          selectionLabwareComponent.push(
            <Col md={6} s={12}>
              <div
                className={`diluent-labware-container ${
                  labwareTroughList[lIndx].LabwareID === normalizationState.selectedDiluentLabwareID ? ' selected' : ''
                } `}
                onClick={() => {
                  this.handleDiluentLabwareClick(labwareTroughList[lIndx].LabwareID);
                }}
              >
                <img className="diluent-labware" alt="diluent-labware" src={labwareTroughList[lIndx].image} />
                <p className="labware-name">{labwareTroughList[lIndx].name}</p>
              </div>
            </Col>,
          );
        }
        centerPanel = (
          <div className="center-panel" style={{width: '35%'}}>
            {selectionLabwareComponent}
          </div>
        );
        break;
      }
      case 4:
        centerPanel = (
          <div className="center-panel" style={{width: '45%'}}>
            <NormalizationViewDataPreview normalizationState={normalizationState} diluentVolumeView />
          </div>
        );
        break;
      default:
        break;
    }
    return centerPanel;
  }

  createLeftPanel(currentWizardView) {
    const {
      appStateAction,
      normalizationState,
      setCsvFileName,
      setCsvRawData,
      setCsvData,
      setCsvTotalRow,
      setReagentName,
      setPreviewData,
      setTargetConcentration,
      setLowestConcentration,
      setSelectedColumnIndex,
      setNormalizationCurrentVolume,
      setAllowedToNext,
      setDiluentName,
    } = this.props;
    let leftPanel = null;

    switch (currentWizardView) {
      case 1:
        leftPanel = (
          <div className="left-panel" style={{width: '30%'}}>
            <NormalizationViewCsvUpload
              normalizationState={normalizationState}
              showLoading={(text) => appStateAction.showLoading(text)}
              hideLoading={() => appStateAction.hideLoading()}
              fileIsNotSupportedHandler={() => appStateAction.showSnackbar(Feedback.ERROR, fileIsNotSupportedMessage)}
              setCsvFileName={(csvFileName) => setCsvFileName(csvFileName)}
              setCsvRawData={(csvRawData) => setCsvRawData(csvRawData)}
              setCsvData={(csvData) => setCsvData(csvData)}
              setCsvTotalRow={(totalRow) => setCsvTotalRow(totalRow)}
              setReagentName={(reagentName) => setReagentName(reagentName)}
              setPreviewData={(previewData) => setPreviewData(previewData)}
              setTargetConcentration={setTargetConcentration}
              setLowestConcentration={setLowestConcentration}
              setSelectedColumnIndex={setSelectedColumnIndex}
              setAllowedToNext={(isAllowedToNext, index) =>
                this.handleChangeAllowedToNext(isAllowedToNext, normalizationState.startRow, index)
              }
              saveProtocol={() => {} /* appStateAction.saveProtocol() */}
              setIsCsvChanged={(isChanged) => this.setState({isCsvChanged: isChanged})}
            />
          </div>
        );
        break;
      case 2:
        leftPanel = (
          <div className="left-panel" style={{width: '25%'}}>
            <NormalizationViewTargetSetting
              normalizationState={normalizationState}
              setTargetConcentration={setTargetConcentration}
              setNormalizationCurrentVolume={setNormalizationCurrentVolume}
              setPreviewData={setPreviewData}
            />
          </div>
        );
        break;
      case 3: {
        const {RED_TEXT, BLUE_TEXT} = sideMenuSelectNormalizationModeMessage;
        const {diluentName, previewData} = normalizationState;

        let totalDiluent = 0;
        for (let index = 0; index < previewData.length; index += 1) {
          totalDiluent += previewData[index].diluentVol * 10;
        }
        leftPanel = (
          <div className="left-panel" style={{width: '25%'}}>
            <div className="title">
              <h4 className="red">{RED_TEXT}</h4>
              <h5 className="blue">{BLUE_TEXT}</h5>
            </div>
            <div className="diluent-info-container">
              <p className="total-diluent-label">Mininum Diluent Needed : {totalDiluent} μL</p>
              <p className="diluent-label">
                Diluent Name <span className="red">*</span>
              </p>
              <input
                className="diluent-input"
                type="text"
                defaultValue={diluentName}
                onChange={(evt) => {
                  const {allowedToNext, selectedDiluentLabwareID} = normalizationState;
                  if (evt.target.value === '') setAllowedToNext(false);
                  else if (!allowedToNext && evt.target.value.trim() !== '' && selectedDiluentLabwareID !== 0) {
                    setAllowedToNext(true);
                  }
                }}
                onBlur={(evt) => {
                  setDiluentName(evt.target.value);
                }}
              />
            </div>
          </div>
        );
        break;
      }
      case 4:
        leftPanel = (
          <div className="left-panel" style={{width: '30%'}}>
            <NormalizationViewDataResume normalizationState={normalizationState} />
          </div>
        );
        break;
      default:
        break;
    }

    return leftPanel;
  }

  render() {
    const {normalizationState} = this.props;
    const {currentWizardView, allowedToNext, totalRow, startRow} = normalizationState;

    const leftPanel = this.createLeftPanel(currentWizardView);
    const centerPanel = this.createCenterPanel(currentWizardView);
    const rightPanel = this.createRightPanel(currentWizardView);
    const footerButtons = this.createFooterButtons(currentWizardView, allowedToNext);

    return (
      <div className="normalization-container-old">
        <div className="main-content">
          {leftPanel}
          {centerPanel}
          {rightPanel}
        </div>
        <div className="footer">
          <div className="footer-info">Total Rows: {totalRow <= 0 ? 0 : totalRow - (startRow - 1)}</div>
          <div className="footer-button">{footerButtons}</div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    pipettingparameterState: state.pipettingparameterState,
    carddetailState: state.carddetailState,
    cardState: state.cardState,
    normalizationState: state.normalizationState,
    labwareState: state.labwareState,
    appState: state.appState,
    temporaryState: state.temporaryState,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    appStateAction: bindActionCreators(AppStateAction, dispatch),
    modalStateAction: bindActionCreators(ModalStateAction, dispatch),
    decrementCurrentWizardView: () => dispatch(NormalizationStateAction.decrementCurrentWizardView()),
    incrementCurrentWizardView: () => dispatch(NormalizationStateAction.incrementCurrentWizardView()),
    setCsvFileName: (csvFileName) => dispatch(NormalizationStateAction.setCsvFileName(csvFileName)),
    setCsvRawData: (csvRawData) => dispatch(NormalizationStateAction.setCsvRawData(csvRawData)),
    setCsvData: (csvData) => dispatch(NormalizationStateAction.setCsvData(csvData)),
    setCsvTotalRow: (totalRow) => dispatch(NormalizationStateAction.setCsvTotalRow(totalRow)),
    setCsvDelimiter: (delimiter) => dispatch(NormalizationStateAction.setCsvDelimiter(delimiter)),
    setCsvStartRow: (startRow) => dispatch(NormalizationStateAction.setCsvStartRow(startRow)),
    setCsvColumnInFirstRow: (isColumnInFirstRow) =>
      dispatch(NormalizationStateAction.setCsvColumnInFirstRow(isColumnInFirstRow)),
    setWellIncrementPattern: (wellIncrementPattern) =>
      dispatch(NormalizationStateAction.setWellIncrementPattern(wellIncrementPattern)),
    setSelectedColumnIndex: (selectedColumnIndex) =>
      dispatch(NormalizationStateAction.setSelectedColumnIndex(selectedColumnIndex)),
    setTargetConcentration: (targetConcentration) =>
      dispatch(NormalizationStateAction.setTargetConcentration(targetConcentration)),
    setLowestConcentration: (targetConcentration) =>
      dispatch(NormalizationStateAction.setLowestConcentration(targetConcentration)),
    setNormalizationCurrentVolume: (currentVolume) =>
      dispatch(NormalizationStateAction.setNormalizationCurrentVolume(currentVolume)),
    resetNormalizationCurrentVolume: (currentVolume) =>
      dispatch(NormalizationStateAction.resetNormalizationCurrentVolume(currentVolume)),
    setReagentName: (reagentName) => dispatch(NormalizationStateAction.setReagentName(reagentName)),
    setDiluentName: (diluentName) => dispatch(NormalizationStateAction.setDiluentName(diluentName)),
    setDiluentLabwareID: (selectedDiluentLabwareID) =>
      dispatch(NormalizationStateAction.setDiluentLabwareID(selectedDiluentLabwareID)),
    setAllowedToNext: (allowedToNext) => dispatch(NormalizationStateAction.setAllowedToNext(allowedToNext)),
    setPreviewData: (previewData) => dispatch(NormalizationStateAction.setPreviewData(previewData)),
    normalizationStateActionResetNormalizationState: () => dispatch(NormalizationStateAction.resetNormalizationState()),
    taskListBusinessFinishNormalization: bindActionCreators(finishNormalization, dispatch),
    temporaryStateActionRemoveTemporaryState: bindActionCreators(removeTemporaryState, dispatch),
    cardStateActionRestoreCardState: bindActionCreators(restoreCardState, dispatch),
    cardStateActionRestoreCardTaskState: bindActionCreators(restoreCardTaskState, dispatch),
    protocolEditorActionSetSelectedLabwareID: bindActionCreators(setSelectedLabwareID, dispatch),
    setDefaultTargetConcentration: bindActionCreators(NormalizationStateAction.setDefaultTargetConcentration, dispatch),
    resetDefaultCurrentVolume: bindActionCreators(NormalizationStateAction.resetDefaultCurrentVolume, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(NormalizationContainer);

NormalizationContainer.propTypes = {
  normalizationState: PropTypes.any.isRequired,
  cardState: PropTypes.object.isRequired,
  appStateAction: PropTypes.any.isRequired,
  modalStateAction: PropTypes.any.isRequired,
  decrementCurrentWizardView: PropTypes.func.isRequired,
  incrementCurrentWizardView: PropTypes.func.isRequired,
  setCsvFileName: PropTypes.func.isRequired,
  setCsvRawData: PropTypes.func.isRequired,
  setCsvData: PropTypes.func.isRequired,
  setCsvTotalRow: PropTypes.func.isRequired,
  setCsvDelimiter: PropTypes.func.isRequired,
  setCsvStartRow: PropTypes.func.isRequired,
  setCsvColumnInFirstRow: PropTypes.func.isRequired,
  setWellIncrementPattern: PropTypes.func.isRequired,
  setSelectedColumnIndex: PropTypes.func.isRequired,
  setTargetConcentration: PropTypes.func.isRequired,
  setLowestConcentration: PropTypes.func.isRequired,
  setNormalizationCurrentVolume: PropTypes.func.isRequired,
  setReagentName: PropTypes.func.isRequired,
  setDiluentName: PropTypes.func.isRequired,
  setAllowedToNext: PropTypes.func.isRequired,
  setDiluentLabwareID: PropTypes.func.isRequired,
  setPreviewData: PropTypes.func.isRequired,
  labwareState: PropTypes.any.isRequired,
  taskListBusinessFinishNormalization: PropTypes.func.isRequired,
  normalizationStateActionResetNormalizationState: PropTypes.func.isRequired,
  temporaryState: PropTypes.object,
  temporaryStateActionRemoveTemporaryState: PropTypes.func.isRequired,
  cardStateActionRestoreCardState: PropTypes.func.isRequired,
  cardStateActionRestoreCardTaskState: PropTypes.func.isRequired,
  protocolEditorActionSetSelectedLabwareID: PropTypes.func.isRequired,
  resetNormalizationCurrentVolume: PropTypes.func.isRequired,
  setDefaultTargetConcentration: PropTypes.func.isRequired,
  resetDefaultCurrentVolume: PropTypes.func.isRequired,
};

NormalizationContainer.defaultProps = {
  temporaryState: {},
};
